import { styled, Box } from "@mui/material";

export const CustomUIRoot = styled(Box)(({ theme, show }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  color: "#24292b",
  width: "100%",
  height: "100%",
  position: "fixed",
  left: 0,
  top: 0,
  transition: "all ease-in-out 0.5s",
  pointerEvents: "none",
  zIndex: 99,
  "&:after": {
    content: '""',
    width: "100%",
    height: "20vh",
    position: "absolute",
    bottom: 0,
    left: 0,
  },
}));
